export { default, getServerSideProps } from 'pages/[lang]/[...slug]';

export const config = { amp: 'hybrid' };
